import { MaterialCommunityIcons, MaterialIcons } from "@expo/vector-icons";
import { Box, Button, Divider, Icon, Text, VStack } from "native-base";
import React, { useState } from "react";
import { Linking } from "react-native";

import { CONTACT_EMAIL, CONTACT_WHATSAPP_URL } from "@/config/constants";
import { isIos } from "@/utils/platform";

import Modal from "../Modal";

type SacButtonProps = {
  floatMode?: boolean;
};

const SacButton = ({ floatMode = true }: SacButtonProps) => {
  const [modalVisile, setModalVisible] = useState(false);

  const onPressContact = (type: "whats" | "email") => {
    switch (type) {
      case "whats":
        Linking.openURL(CONTACT_WHATSAPP_URL);
        break;
      case "email":
        Linking.openURL(`mailto:${CONTACT_EMAIL}`);
        break;
      default:
        break;
    }
  };

  const boxProps = floatMode
    ? { position: "absolute", bottom: isIos ? "94px" : "64px", right: "10px" }
    : {};

  return (
    <>
      <Box {...boxProps} zIndex={9999}>
        <Button
          variant="solid"
          colorScheme="white"
          borderRadius={100}
          shadow="4"
          px={6}
          leftIcon={
            <Icon as={<MaterialIcons name="contact-support" />} size="lg" color="primary.600" />
          }
          onPress={() => setModalVisible(true)}>
          <Text bold color="primary.600">
            Ajuda
          </Text>
        </Button>
      </Box>
      <Modal
        isOpen={modalVisile}
        onClose={() => setModalVisible(false)}
        Header="Entre em contato conosco"
        Body={
          <VStack pb="24">
            <Button
              py="4"
              justifyContent="flex-start"
              variant="ghost"
              onPress={() => onPressContact("whats")}
              leftIcon={
                <Icon as={<MaterialCommunityIcons name="whatsapp" />} size="lg" color="green.600" />
              }>
              <Text>Whatsapp</Text>
            </Button>
            <Divider />
            <Button
              py="4"
              justifyContent="flex-start"
              variant="ghost"
              onPress={() => onPressContact("email")}
              leftIcon={
                <Icon
                  as={<MaterialCommunityIcons name="email-outline" />}
                  size="lg"
                  color="primary.600"
                />
              }>
              <Text>E-mail</Text>
            </Button>
            <Divider />
          </VStack>
        }
      />
    </>
  );
};

export default SacButton;
